(function () {
  'use strict';

  var MAX = 12;
  var VALID_EXTS = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif'];
  var stateMap = {};

  function isValidImage(file) {
    if (file.type && file.type.startsWith('image/')) return true;

    var ext = (file.name || '').split('.').pop().toLowerCase();
    return VALID_EXTS.indexOf(ext) !== -1;
  }

  function isDuplicate(existing, file) {
    return existing.some(function (item) {
      return (
        item.name === file.name &&
        item.size === file.size &&
        item.lastModified === file.lastModified
      );
    });
  }

  function distribute(slots, files) {
    var ok = true;

    slots.forEach(function (slot, index) {
      if (index < files.length) {
        try {
          var transfer = new DataTransfer();
          transfer.items.add(files[index]);
          slot.files = transfer.files;
          slot.disabled = false;

          if (
            !slot.files ||
            slot.files.length !== 1 ||
            slot.files[0].name !== files[index].name ||
            slot.files[0].size !== files[index].size
          ) {
            ok = false;
          }
        } catch (error) {
          ok = false;
          slot.disabled = true;
        }
      } else {
        try {
          slot.files = new DataTransfer().files;
        } catch (error) {
          // Slot is disabled below, so it won't be submitted.
        }

        slot.disabled = true;
      }
    });

    return ok;
  }

  function initUpload(container) {
    var button = container.querySelector('.xv-upload__btn');
    var chooser = container.querySelector('.xv-upload__chooser');
    var thumbnails = container.querySelector('.xv-upload__thumbs');
    var count = container.querySelector('.xv-upload__count');
    var errorMessage = container.querySelector('.xv-upload__error');
    var slots = Array.from(
      container.querySelectorAll('.xv-upload__slot')
    );

    if (
      !button ||
      !chooser ||
      !thumbnails ||
      !count ||
      !errorMessage ||
      slots.length !== MAX
    ) {
      return;
    }

    if (container.dataset.xvInitialized === 'true') return;
    container.dataset.xvInitialized = 'true';

    var key = container.dataset.uploadKey;
    var required = container.dataset.photoRequired === 'true';

    if (!stateMap[key]) {
      stateMap[key] = {
        files: [],
        distributionOk: true
      };
    }

    var state = stateMap[key];

    function showError(message) {
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;

      if (message) {
        button.focus();
      }
    }

    function updateCount() {
      if (state.files.length === 0) {
        count.textContent = '';
        count.hidden = true;
        return;
      }

      count.textContent =
        state.files.length + ' of ' + MAX + ' photos selected';
      count.hidden = false;
    }

    function renderThumbnails() {
      thumbnails.innerHTML = '';

      state.files.forEach(function (file, index) {
        var imageUrl = URL.createObjectURL(file);

        var item = document.createElement('div');
        item.className = 'xv-thumb';
        item.setAttribute('role', 'listitem');

        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = 'Photo ' + (index + 1) + ': ' + file.name;
        image.className = 'xv-thumb__img';

        image.onload = function () {
          URL.revokeObjectURL(imageUrl);
        };

        image.onerror = function () {
          URL.revokeObjectURL(imageUrl);
        };

        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'xv-thumb__remove';
        removeButton.setAttribute(
          'aria-label',
          'Remove photo ' + (index + 1)
        );
        removeButton.textContent = '×';

        removeButton.addEventListener('click', function () {
          state.files.splice(index, 1);
          showError('');
          refresh();
        });

        item.appendChild(image);
        item.appendChild(removeButton);
        thumbnails.appendChild(item);
      });
    }

    function refresh() {
      state.distributionOk = distribute(slots, state.files);
      renderThumbnails();
      updateCount();

      if (!state.distributionOk && state.files.length > 0) {
        showError(
          'Photo assignment failed. Please refresh or use a different browser.'
        );
      }
    }

    if (state.files.length > 0) {
      refresh();
    }

    button.addEventListener('click', function () {
      chooser.click();
    });

    chooser.addEventListener('change', function () {
      var incoming = Array.from(chooser.files || []);
      showError('');

      var invalidFiles = incoming.filter(function (file) {
        return !isValidImage(file);
      });

      if (invalidFiles.length > 0) {
        showError(
          'Please upload image files only (JPG, PNG, WEBP or HEIC).'
        );
        chooser.value = '';
        return;
      }

      var merged = state.files.slice();

      incoming.forEach(function (file) {
        if (!isDuplicate(merged, file)) {
          merged.push(file);
        }
      });

      if (merged.length > MAX) {
        showError(
          'You can upload a maximum of ' + MAX + ' photos.'
        );
        chooser.value = '';
        return;
      }

      state.files = merged;
      chooser.value = '';
      refresh();
    });

    container._validate = function () {
      if (required && state.files.length === 0) {
        showError('Please upload at least one photo.');
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        return false;
      }

      if (state.files.length > MAX) {
        showError(
          'You can upload a maximum of ' + MAX + ' photos.'
        );
        return false;
      }

      if (!state.distributionOk && state.files.length > 0) {
        showError(
          'Photo upload failed. Please refresh and try again.'
        );
        return false;
      }

      showError('');
      return true;
    };
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || form.tagName !== 'FORM') return;

      var productForm = form.closest(
        'product-form-component[data-photo-upload="true"]'
      );

      if (!productForm) return;

      var uploadContainer =
        productForm.querySelector('.xv-upload');

      if (!uploadContainer) {
        event.preventDefault();
        console.error(
          '[xv-upload] Upload container not found. Submit blocked.'
        );
        return;
      }

      if (typeof uploadContainer._validate !== 'function') {
        event.preventDefault();

        var initializationError =
          uploadContainer.querySelector('.xv-upload__error');

        if (initializationError) {
          initializationError.textContent =
            'Photo upload is not ready. Please refresh and try again.';
          initializationError.hidden = false;
        }

        console.error(
          '[xv-upload] Validation not initialized. Submit blocked.'
        );
        return;
      }

      if (!uploadContainer._validate()) {
        event.preventDefault();
      }
    },
    true
  );

  function initAll(root) {
    root = root || document;

    if (root.matches && root.matches('.xv-upload')) {
      initUpload(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.xv-upload').forEach(initUpload);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();